import React from 'react';
import {DividedListItem, DividedListItemProps} from './DividedListItem';
import {LineTextBlock, LineTextBlockProps} from '../text';
import {VerticalSpacer} from '../spacer/VerticalSpacer';
import {AccentColorOptions} from 'epic-ue-theme';
import styled from 'styled-components';
import {AnimateOnViewWrap} from '../../wraps/animation';

export const DividedListWrapper = styled.div`
    hr {
        margin: 0;
        border-color: ${(p) => p.theme.palette.neutral.steel};
        border-style: solid;
        border-width: 1px 0 0 0;
        opacity: 1;
    }
`;

export type DividedListVariantOptions = 'offset-description' | 'standard';
export interface DividedListProps {
    accentColor?: AccentColorOptions;
    className?: string;
    listHeading?: LineTextBlockProps;
    items?: DividedListItemProps[];
    variant?: DividedListVariantOptions;
    hidden?: boolean;
    dynamicSection?: boolean;
}

export const DividedList = (props: DividedListProps): JSX.Element | null => {
    const {
        accentColor,
        className,
        listHeading,
        items = [],
        variant = 'standard',
        hidden = false,
        dynamicSection
    } = props;

    if (hidden) return null;

    return (
        <DividedListWrapper className={`divided-list ${className || ''}`}>
            {dynamicSection && <VerticalSpacer variant="custom" spacing={4} downSmSpacing={0} />}
            <LineTextBlock
                {...listHeading}
                accentColor={accentColor}
                button={{...listHeading?.button, type: 'tertiary'}}
            />
            <VerticalSpacer variant="custom" spacing={5} downSmSpacing={3} />
            {items.map((item, index) => {
                return (
                    <div key={`${item.headline}-${index}-item-outer`}>
                        <DividedListItem
                            accentColor={accentColor || item.accentColor}
                            key={`${item.headline}-${index}-item-inner`}
                            topEyebrow={item.topEyebrow}
                            image={item.image}
                            headline={item.headline}
                            description={item.description}
                            bottomEyebrow={item.bottomEyebrow}
                            callToAction={item.callToAction}
                            href={item.href}
                            className={`${item.className ? item.className : ''}`}
                            caption={item?.caption}
                            variant={variant}
                        />
                        {index !== items.length - 1 && (
                            <>
                                <VerticalSpacer variant="custom" spacing={5} downSmSpacing={3} />
                                <AnimateOnViewWrap translateY={30}>
                                    <hr key={`${item.headline}-${index}-wide-hr`} />
                                </AnimateOnViewWrap>
                                <VerticalSpacer variant="custom" spacing={5} downSmSpacing={3} />
                            </>
                        )}
                    </div>
                );
            })}
        </DividedListWrapper>
    );
};
